<template>
  <dialog class="modal modal-bottom sm:modal-middle modal-open">
    <div class="modal-box">
      <h3 class="font-bold text-lg">{{ $t('submitQuestion') }}</h3>

      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">{{ $t('yourEmail') }}</span>
        </div>
        <input
          v-model="email"
          type="text"
          placeholder="Type here"
          class="input input-bordered w-full bg-white"
        />
      </label>

      <label class="form-control w-full">
        <div class="label">
          <span class="label-text">{{ $t('question') }}</span>
        </div>
        <textarea
          v-model="message"
          class="textarea textarea-bordered w-full bg-white"
          :placeholder="$t('typeHere')"
        />
      </label>

      <div class="modal-action">
        <button class="btn btn-success" :disabled="!email || !message" @click="onSubmit">
          {{ $t('submit') }}
        </button>
        <button class="btn btn-error" @click="$emit('close')">{{ $t('close') }}</button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toast-notification'

import { axiosInstance } from '@/utils/axios'

const toast = useToast({ position: 'top-right' })
const { t } = useI18n()

const email = ref('')
const message = ref('')

const props = defineProps<{
  activity_id: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const onSubmit = async () => {
  await axiosInstance.post(`activities/question/${props.activity_id}`, {
    email: email.value,
    message: message.value
  })

  toast.success(t('questionSent'))
  emit('close')
}
</script>
